// HighRps and multipax for SALE
export const SALE_CONFIG = {
    START_TIME: '2025-09-22T00:00:00',
    END_TIME: '2025-10-02T23:59:59',
}